<template>
  <div class="rise-in">
    <!-- Header -->
    <div
      class="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8"
    >
      <div>
        <h1 class="page-title">Research Projects</h1>
        <p class="page-subtitle">Select a study to check in a patient.</p>
      </div>
      <router-link
        class="btn btn-secondary btn-md self-start sm:self-auto"
        :to="{ name: 'ExportData' }"
      >
        <font-awesome-icon icon="download" />
        Export data
      </router-link>
    </div>

    <!-- Loading -->
    <div
      v-if="loading"
      class="flex items-center gap-2 text-ink-muted py-12 justify-center"
    >
      <font-awesome-icon icon="circle-notch" spin class="text-brand-600" />
      Loading projects…
    </div>

    <!-- Project grid -->
    <div v-else class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5">
      <div
        v-for="p in orderedProjects"
        :key="p.id"
        class="card card-hover card-pad flex flex-col"
      >
        <div class="flex items-start justify-between mb-5">
          <span
            class="w-12 h-12 rounded-2xl bg-brand-50 text-brand-600 flex items-center justify-center text-xl"
          >
            <font-awesome-icon icon="wind" />
          </span>
          <span v-if="!p.active" class="pill pill-muted">Inactive</span>
        </div>

        <h3 class="text-lg font-bold text-ink leading-tight">
          {{ getProjectName(p) }}
        </h3>
        <p
          class="text-xs font-semibold uppercase tracking-wider text-ink-muted mt-1"
        >
          {{ (p.id || '').toUpperCase() }}
        </p>

        <router-link
          :to="{ name: 'PatientCheckIn', params: { projectSlug: p.id } }"
          class="btn btn-primary btn-md w-full mt-6"
        >
          Select
          <font-awesome-icon icon="arrow-right" class="text-xs" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { actionTypes, getterTypes } from 'store/patient'

export default {
  name: 'Dashboard',
  computed: {
    ...mapGetters({
      projects: getterTypes.projects,
      loading: getterTypes.loading,
    }),
    orderedProjects() {
      // Sort projects to match original order: bro -> trx -> bex
      const order = ['bro', 'trx', 'bex']
      return [...this.projects].sort((a, b) => {
        const indexA = order.indexOf((a.id || '').toLowerCase())
        const indexB = order.indexOf((b.id || '').toLowerCase())
        if (indexA === -1) return 1
        if (indexB === -1) return -1
        return indexA - indexB
      })
    },
  },
  created() {
    this.$store.dispatch(actionTypes.loadProjects)
  },
  methods: {
    getProjectName(p) {
      const id = (p.id || '').toLowerCase()
      if (id === 'bex') return 'BigExBrEss'
      if (id === 'bro') return 'BrOSA'
      if (id === 'trx') return 'TripleX'
      return p.name || p.id.toUpperCase()
    },
  },
}
</script>
